import {
  PROFESSIONAL_REFERENCE_LOADING,
  PROFESSIONAL_REFERENCE_SUCCESS,
  PROFESSIONAL_REFERENCE_FAILED,
  PROF_REF_ADD_LOADING,
  PROF_REF_ADD_SUCCESS,
  PROF_REF_ADD_FAILED,
  PROF_REF_REMOVE_LOADING,
  PROF_REF_REMOVE_SUCCESS,
  PROF_REF_REMOVE_FAILED,
  PROF_REF_SAVE_LOADING,
  PROF_REF_SAVE_SUCCESS,
  PROF_REF_SAVE_FAILED
} from "../Constants/professionalReferenceConstants";

export const professionalReferenceReducer = (
  state = { profReferenceData: [] },
  action
) => {
  switch (action.type) {
    case PROFESSIONAL_REFERENCE_LOADING:
      return { loading: true, profReferenceData: [] };
    case PROFESSIONAL_REFERENCE_SUCCESS:
      return { loading: false, profReferenceData: action.payload };
    case PROFESSIONAL_REFERENCE_FAILED:
      return { loading: false, error: action.profReferenceData };
    default:
      return state;
  }
};

export const profRefAddReducer = (
  state = { profRefData: [] },
  action
) => {
  switch (action.type) {
    case PROF_REF_ADD_LOADING:
      return { loading: true, profRefData: [] };
    case PROF_REF_ADD_SUCCESS:
      return { loading: false, profRefData: action.payload };
    case PROF_REF_ADD_FAILED:
      return { loading: false, error: action.profRefData };
    default:
      return state;
  }
};

export const profRefRemoveReducer = (
  state = { profRefRemoveData: [] },
  action
) => {
  switch (action.type) {
    case PROF_REF_REMOVE_LOADING:
      return { loading: true, profRefRemoveData: [] };
    case PROF_REF_REMOVE_SUCCESS:
      return { loading: false, profRefRemoveData: action.payload };
    case PROF_REF_REMOVE_FAILED:
      return { loading: false, error: action.profRefRemoveData };
    default:
      return state;
  }
};

export const profRefSaveReducer = (
  state = { profRefSaveData: [] },
  action
) => {
  switch (action.type) {
    case PROF_REF_SAVE_LOADING:
      return { loading: true, profRefSaveData: [] };
    case PROF_REF_SAVE_SUCCESS:
      return { loading: false, profRefSaveData: action.payload };
    case PROF_REF_SAVE_FAILED:
      return { loading: false, error: action.profRefSaveData };
    default:
      return state;
  }
};